// test2003
(2003 && 0);
